import { render, staticRenderFns } from "./OrderItemRow.vue?vue&type=template&id=1913395a&"
import script from "./OrderItemRow.vue?vue&type=script&lang=ts&"
export * from "./OrderItemRow.vue?vue&type=script&lang=ts&"
import style0 from "./OrderItemRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1913395a')) {
      api.createRecord('1913395a', component.options)
    } else {
      api.reload('1913395a', component.options)
    }
    module.hot.accept("./OrderItemRow.vue?vue&type=template&id=1913395a&", function () {
      api.rerender('1913395a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrderItemRow.vue"
export default component.exports